import src from "IMAGE";
export default { src, width: 400, height: 70, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AKmpqZWPj499cnJyZX5+fnCMjIx7gICAb2hoaFp0dHRkFG8PwN8r4/IAAAAASUVORK5CYII="};
